/* global __webpack_public_path__:true */
(function (jimdoData) {
    "use strict";

    __webpack_public_path__ = jimdoData.cdnUrl;

})(require('jimdoData'));



/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/webpackInitPublicPath.js
 ** module id = 253
 ** module chunks = 99 100 236 237 238 240 241 243
 **/